// extracted by mini-css-extract-plugin
export var avatarContainer = "_hc-0";
export var avatarTypingWave = "_hc-i";
export var gray = "_hc-f";
export var green = "_hc-c";
export var icon = "_hc-9";
export var image = "_hc-1";
export var lg = "_hc-6";
export var md = "_hc-5";
export var presenceDot = "_hc-b";
export var red = "_hc-d";
export var sm = "_hc-4";
export var status = "_hc-a";
export var typingDot = "_hc-h";
export var typingPill = "_hc-g";
export var xl = "_hc-7";
export var xs = "_hc-3";
export var xxl = "_hc-8";
export var xxs = "_hc-2";
export var yellow = "_hc-e";